import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookie from 'js-cookie'
import { MapType, Language, Locale } from '@/util/types'
import playPaneEn from './playPaneEn'
import playPaneZh from './playPaneZh'
import loginEn from './loginEn'
import loginZh from './loginZh'
import app from './app'

const langMap: MapType<Language> = {
  en: 'en_us',
  zh: 'zh_cn',
  cn: 'zh_cn',
}

/**
 * 获取浏览的语言
 */
export function getBrowserLanguage() {
  const key = navigator.language
  const name = (key || '').split('-')[0].toLowerCase()
  const lang = langMap[name] || langMap.en
  return lang
}

/**
 * 从 cookie、浏览器中获取语言
 */
export function getLanguage() {
  const value = cookie.get('userLang') || cookie.get('lang') || getBrowserLanguage()
  const lang = value.toLowerCase().replace(/-/g, '_')
  return lang as Language
}

export const localeMap: MapType<Locale> = {
  en_us: 'en',
  zh_cn: 'zh'
}

/**
 * 获取当前区域设置
 */
export function getCurrentLocale() {
  const lang = getLanguage()
  const locale = localeMap[lang]
  return locale
}

const messages = {
  en: {
    playPane: playPaneEn,
    login: loginEn,
    app: app.en,
  },

  zh: {
    playPane: playPaneZh,
    login: loginZh,
    app: app.zh,
  }
}

export function useI18n() {
  Vue.use(VueI18n)
  const locale = getCurrentLocale()
  const i18n = new VueI18n({
    locale,
    messages,
  })
  return i18n
}
